const form = {
  formId: "new-user-form",
  formField: {
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[01] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[04] Tên người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxId: {
      name: "taxId",
      label: "[05] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    taxAgentName: {
      name: "taxAgentName",
      label: "[06] Tên đại lý thuế (nếu có):",
      type: "text",
      placeholder: "",
    },
    taxAgencyName: {
      name: "taxAgencyName",
      label: "[06] Tên đại lý thuế (nếu có)",
      type: "text",
      placeholder: "",
    },
    taxAgencyId: {
      name: "taxAgencyId",
      label: "[07] Mã số thuế đại lý:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    contractNumber: {
      name: "contractNumber",
      label: "[08] Hợp đồng đại lý thuế: Số:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập số hợp đồng đại lý thuế",
      invalidMsg: "Mã số hợp đồng đại lý thuế không hợp lệ",
    },
    contractDay: {
      name: "contractDay",
      label: "Ngày:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn ngày hợp đồng tính thuế",
    },
    activeAddress: {
      name: "activeAddress",
      label: "[09] Địa chỉ nơi có hoạt động xây dựng, chuyển nhượng BĐS:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ nơi có hoạt động xây dựng, chuyển nhượng BĐS",
    },
    addressCity: {
      name: "addressCity",
      label: "[09c] Tỉnh/Thành phố:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Tỉnh/Thành phố",
    },
    addressDistrict: {
      name: "addressDistrict",
      label: "[09b] Quận/Huyện:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Quận/Huyện",
    },
    addressWard: {
      name: "addressWard",
      label: "[09a] Phường/Xã:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Phường/Xã",
    },
    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
